import { applyTicketFilters, ticketFilterParams } from "../listFilters";
import { connect } from "react-redux";
import React from "react";
import "antd/dist/antd.css";
// import "./index.css";
import { Button, Col, Row, Table } from "antd";
import { withRouter } from "react-router-dom";
import { authAxios } from "../utils";
import { ListStatusURL, ticketsListURL } from "../constants";
import moment from "moment";
import { AdvancedSearchForm } from "./Component";
import Cookies from "universal-cookie";
import FilterOutlined from "@ant-design/icons/lib/icons/FilterOutlined";
const cookies = new Cookies();

class Danhsachyeucau extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: "",
    pagination: { pageSize: 10 },
    lsStatus: [],
    searching: false,
    paramsSearch: {},
  };
  componentDidMount() {
    this.setState({ loading: true });
    this.fetchStatusListAPI();
    this.fetchTicketListAPI({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "descend",
    });
  }

  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
      sortedInfo: sorter,
    });
    this.fetchTicketListAPI({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      ...filters,
      ...this.state.paramsSearch,
    });
  };

  fetchStatusListAPI = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(ListStatusURL)
      .then((res) => {
        let lsTemp = [{ label: "Tất cả", value: "all" }];
        res.data.results.map((item, index) => {
          lsTemp.push({ label: `${item.name}`, value: `${item.name}` });
        });

        this.setState({ lsStatus: lsTemp });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };

  fetchTicketListAPI = (params = {}) => {
    params = ticketFilterParams(params, false);
    const requestId = this.ticketRequestId = (this.ticketRequestId || 0) + 1;
    this.setState({ loading: true });
    params.typeView = "pendingAccept";
    authAxios(cookies.get("token"))
      .get(ticketsListURL, { params: params })
      .then((res) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({
          data: res.data.results,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({ error: err, loading: false });
        if (err.response?.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  filterTicketList = (params = {}) => {
    applyTicketFilters(this, params);
  };

  // SearchTicketList = (value, event) => {
  //     let {sortKey, sortDirection, pageSize} = this.state;
  //     const pager = {...this.state.pagination};
  //     pager.current = 1;
  //     pager.page = 1;
  //     this.setState({searchKey:value,pagination:pager})
  //     this.fetchTicketListAPI({
  //         page_size: this.state.pagination.pageSize,
  //         page: 1,
  //         columnSort: 'id',
  //         typeSort: 'descend',
  //         search: value,
  //     })
  // }
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  callBackFilter = (values) => {
    this.filterTicketList(values);
  };
  render() {
    let { loading, data, total_page, pagination } = this.state;
    let { userPermission } = this.props;
    const columns = [
      // {
      //     title: "STT",
      //     dataIndex: "index",
      //     key: "index",
      //     render: (value, item, index) => ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
      //     sorter: (a, b) => a.index - b.index,
      //     sortDirections: ['descend', 'ascend', 'descend'],
      // },

      {
        title: "Mã yêu cầu",
        dataIndex: "ticket_code",
        key: "ticket_code",
        sorter: (a) => a,
        render: (value, item, index) => (
          <a href={"/tickets/" + item.id}>{value}</a>
        ),
        filterKey: "ticket_code",
        type: "text",
        canSearch: true,
        fixed: "left",
        // width: 150,
        width: "7%",
      },
      {
        title: "Loại yêu cầu",
        dataIndex: "ticket_type_name",
        key: "ticket_type_name",
        sorter: (a) => a,
        filterKey: "ticket_type_name",
        width: "11%",
        type: "text",
        canSearch: true,
      },
      {
        title: "Tiêu đề",
        dataIndex: "title",
        key: "title",
        ellipsis: true,
        filterKey: "title",
        width: "20%",
        type: "text",
        canSearch: true,
        // sortDirections: ['ascend', 'descend', 'ascend'],
        // sorter: (a, b) => a.title - b.title,
      },
      {
        title: "Văn phòng",
        dataIndex: "vanphong_name",
        key: "vanphong_name",
        filterKey: "vanphong_name",
        width: "6%",
        // filters: [
        //   { text: "DSP", value: "DSP" },
        //   { text: "Seatech", value: "Seatech" }
        // ],
        // filteredValue: filteredInfo.vanphong || null,
        // onFilter: (value, record) => record.vanphong.includes(value),
        sorter: (a) => a,
        type: "text",
        canSearch: true,
        // sortOrder: sortedInfo.columnKey === "vanphong" && sortedInfo.order
      },
      {
        title: "Ngày mong muốn",
        dataIndex: "duedate",
        key: "duedate",
        filterKey: "duedate",
        width: "7%",
        render: (text, record) => moment(text).format("L"),
        sorter: (a) => a,
        type: "date",
        canSearch: true,
      },
      {
        title: "Người yêu cầu",
        dataIndex: "username_create",
        key: "username_create",
        filterKey: "username_create",
        width: "7%",
        sorter: (a) => a,
        type: "text",
        canSearch: true,
      },
      {
        title: "Trạng thái",
        dataIndex: "ticket_status_name",
        key: "ticket_status_name",
        filterKey: "ticket_status_name",
        width: "7%",
        type: "text",
        canSearch: false,
        // filters: [{ text: "Mới", value: "Mới" }, { text: "Đã duyệt", value: "Đã duyệt" },{ text: "Đang xử lý", value: "Đang xử lý" },{ text: "Hoàn thành", value: "Hoàn thành" }],
        // filteredValue: filteredInfo.trangthai || null,
        // onFilter: (value, record) => record.trangthai.includes(value),
        sorter: (a) => a,
        // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
        render: (text, record) => (
          <a
            style={{
              backgroundColor: record.color,
              color: "#ffffff",
              padding: "3px 5px 3px 5px",
            }}
          >
            {text}
          </a>
        ),
      },
      {
        title: "Cập nhật bởi",
        dataIndex: "updating_user_name",
        key: "updating_user_name",
        filterKey: "updating_user_name",
        width: "7%",
        type: "text",
        canSearch: true,
      },
    ];
    const toggleSearchForm = () => {
      const searching = this.state.searching;
      this.setState({ searching: !searching });
    };
    const onFilterTrangThai = (e) => {
      let obj = {};
      if (e.target.value !== "all") {
        obj.ticket_status_name = e.target.value;
      } else {
        obj.ticket_status_name = undefined;
      }
      this.filterTicketList(obj);
    };
    return (
      <>
        <Row>
          <Col sm={16} style={{ float: "left", marginBottom: 15 }}>
            {/*<Radio.Group*/}
            {/*  options={this.state.lsStatus}*/}
            {/*  onChange={onFilterTrangThai}*/}
            {/*  defaultValue={'all'}*/}
            {/*  optionType="button"*/}
            {/*  buttonStyle="solid"*/}
            {/*/>*/}
            <Button
              onClick={toggleSearchForm}
              style={{ marginLeft: "10px" }}
              icon={<FilterOutlined />}
            >
              Lọc
            </Button>
          </Col>
          {this.state.searching ? (
            <AdvancedSearchForm
              Columns={columns}
              lsStatus={this.state.lsStatus}
              paramsSearch={this.state.paramsSearch}
              callBackFilter={this.callBackFilter}
            />
          ) : null}
        </Row>

        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          scroll={{ x: 768 }}
          // scroll={{ x: 1500 }}
          rowKey="id"
          size="small"
          className="styleTable_1"
          onRow={(record) => ({
            onDoubleClick: () => {
              this.props.history.push(`/tickets/${record.id}`);
              // const win = window.open(`/tickets/${record.id}`, "_blank");
              // win.focus();
            },
          })}
          onChange={this.handleChange}
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
      </>
    );
  }
}

// ReactDOM.render(<App />, document.getElementById("container"));

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    userPermission: state.user.userPermission,
  };
};
// export default connect(mapStateToProps)(withRouter(Danhsachyeucau));

export default withRouter(connect(mapStateToProps)(Danhsachyeucau));
